module.exports = __webpack_public_path__ + "static/img/7.9fb3ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/7.png
// module id = /8JI
// module chunks = 0